// src/util/badgeUtils.js
// Badge formatting and display utilities

import { SECTIONS } from '../config/navConfig';

/**
 * Format badge count for display
 * @param {number} count - Raw count
 * @returns {string|null} - Formatted count or null if 0
 */
export function formatBadgeCount(count) {
  if (!count || count <= 0) {
    return null;
  }
  if (count >= 100) {
    return '99+';
  }
  return String(count);
}

/**
 * Check if an item should show a badge
 * @param {object} item - Menu item
 * @param {object} counts - Badge counts object
 * @returns {string|null} - Badge text or null
 */
export function getBadgeForItem(item, counts) {
  // Only Work section items can have badges
  if (item.section !== SECTIONS.WORK) {
    return null;
  }

  if (!item.badgeKey) {
    return null;
  }

  const count = counts[item.badgeKey];
  return formatBadgeCount(count);
}

/**
 * Badge key to API response field mapping
 * Maps internal badge keys to the fields from navbar-data-cached API
 */
export const BADGE_KEY_MAP = {
  leads_actionable: 'referralCount',
  requestimates_actionable: 'requestCount',
  jobs_actionable: 'jobCount',
  pickupdeliver_actionable: 'pickupCount',
  referrals_actionable: 'referralCount',
  mywork_actionable: 'myWorkCount'
};

/**
 * Transform API response to badge counts object
 * @param {object} apiData - Response from navbar-data-cached API
 * @returns {object} - Badge counts keyed by badge key
 */
export function transformApiToBadgeCounts(apiData) {
  return {
    leads_actionable: apiData.referralCount || 0,
    requestimates_actionable: apiData.requestCount || 0,
    jobs_actionable: apiData.jobCount || 0,
    pickupdeliver_actionable: apiData.pickupCount || 0,
    referrals_actionable: apiData.referralCount || 0,
    mywork_actionable: apiData.myWorkCount || 0
  };
}
